<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import {
    renderPDFReportToIframe,
    type EnhancedIframe,
  } from '@/teoCore/report/generate-pdf-report';
  import { useActiveText, useTeoCore } from '@/utils/teo-context';
  import { useAnalysis } from '@/utils/teo-context/teo-atoms/analysis';
  import { useConfigSetup, useConfigState } from '@/utils/teo-context/teo-atoms/use-config.svelte';
</script>

<script lang="ts">
  const analysis = useAnalysis();
  const configuration = useConfigState();
  const configSetup = useConfigSetup();
  const activeText = useActiveText();

  let iframeRef: EnhancedIframe | null = $state(null);

  let analysisData = $derived(
    analysis.current?.data ?? {
      indices: undefined,
      additional_values: {},
      tpi: undefined,
      report_id: Math.random().toString(36).substring(2, 15),
      created_at: Date.now(),
    },
  );

  const core = useTeoCore();

  let reportData = $derived({
    title: `TEO Report - ${activeText.current.ui.state.title}`,
    indices: analysisData.indices,
    configuration: configuration.current,
    configSetup: configSetup.current,
    statistics: analysisData.additional_values ?? {},
    text: activeText.current.text,
    tpi: analysisData.tpi,
    tpiTarget: core.staticConfig.tpiTarget,
    reportId: analysisData.report_id,
    createdAt: analysisData.created_at,
  });

  $effect(() => {
    renderPDFReportToIframe(reportData, iframeRef);
  });

  onDestroy(() => {
    if (iframeRef?.pdfUrl) {
      URL.revokeObjectURL(iframeRef.pdfUrl);
    }
  });
</script>

<iframe bind:this={iframeRef} style="width:100%;height:600px;border:1px solid #ccc;" title="Report"
></iframe>
